import { createSlice } from '@reduxjs/toolkit';
import { axiosInstance } from '../Axios';
import { toggleUserModal, storeData } from './UiReducer';
import { toggleUserPasswordResetModal } from 'reducers/UiReducer';


const getAxiosConfig = (token) => ({
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${token}`,
  },
});

const getErrorMessage = (error) =>
  error.response && error.response.data.message
    ? error.response.data.message
    : error.message;

const UserReducer = createSlice({
  name: 'user',
  initialState: {

    loginInfo: sessionStorage.getItem('loginInfo')
      ? JSON.parse(sessionStorage.getItem('loginInfo'))
      : null,
    success: false,
    // User states
    userLoading: false,
    userTypeLoading: false,
    userList: [],
    userTypeList: [],
    userError: null,
    // Page permission states
    permissionLoading: false,
    pageList: [],
    permissionError: null,

    roleList: [],
    roleLoading: false,
    roleError: null,

    userPermissions: [],
    userPermissionsLoading: false,
    userPermissionsError: null,


  },
  reducers: {
    // User actions
    createUserRequest(state) {
      state.userLoading = true;
    },
    createUserSuccess(state, action) {
      state.userLoading = false;
    },
    createUserFail(state, action) {
      state.userLoading = false;
      state.userError = action.payload;
    },

    updateUserRequest(state) {
      state.userLoading = true;
    },
    updateUserSuccess(state, action) {
      state.userLoading = false;

    },
    updateUserFail(state, action) {
      state.userLoading = false;
      state.userError = action.payload;
    },
    // Get User List
    getUserListRequest(state) {
      state.userLoading = true;
    },
    getUserListSuccess(state, action) {
      state.userLoading = false;
      state.userList = action.payload;
    },
    getUserListFail(state, action) {
      state.userLoading = false;
      state.userError = action.payload;
    },

    //Get User Type List
    getUserTypeListRequest(state) { 
      state.userTypeLoading = true;
    },
    getUserTypeListSuccess(state, action) {
      state.userTypeLoading = false;
      state.userTypeList = action.payload;
    },
    getUserTypeListFail(state, action) {
      state.userTypeLoading = false;
      state.userError = action.payload;
    },

    // Delete User
    deleteUserRequest(state) {
      state.userLoading = true;
    },
    deleteUserSuccess(state, action) {
      state.userLoading = false;
    },
    deleteUserFail(state, action) {
      state.userLoading = false;
      state.userError = action.payload;
    },
    // Reset User Password
    resetUserRequest(state) {
      state.userLoading = true;
    },
    resetUserSuccess(state, action) {
      state.userLoading = false;
    },
    resetUserFail(state, action) {
      state.userLoading = false;
      state.userError = action.payload;
    },

    // Page List
    getPageListRequest(state) {
      state.permissionLoading = true;
    },
    getPageListSuccess(state, action) {
      state.permissionLoading = false;
      state.pageList = action.payload;
    },
    getPageListFail(state, action) {
      state.permissionLoading = false;
      state.permissionError = action.payload;
    },

    // Assign Permission
    assignPermissionRequest(state) {
      state.permissionLoading = true;
    },
    assignPermissionSuccess(state) {
      state.permissionLoading = false;
    },
    assignPermissionFail(state, action) {
      state.permissionLoading = false;
      state.permissionError = action.payload;
    },

    // Role list actions
    getRoleListRequest(state) {
      state.roleLoading = true;
      state.roleError = null;
    },
    getRoleListSuccess(state, action) {
      state.roleLoading = false;
      state.roleList = action.payload;
    },
    getRoleListFail(state, action) {
      state.roleLoading = false;
      state.roleError = action.payload;
    },

    getUserPermissionsRequest(state) {
      state.userPermissionsLoading = true;
      state.userPermissionsError = null;
    },
    getUserPermissionsSuccess(state, action) {
      state.userPermissionsLoading = false;
      state.userPermissions = action.payload;
    },
    getUserPermissionsFail(state, action) {
      state.userPermissionsLoading = false;
      state.userPermissionsError = action.payload;
    },

    loginRequest(state, action) {
      state.loading = true;
    },
    loginSuccess(state, action) {
      state.loading = false;
      state.loginInfo = action.payload;
      storeData('loginInfo', action.payload);
      state.error = null;
    },
    loginFail(state, action) {
      state.loading = false;
      state.error = action.payload;
    },


  },
});

export const {
  // User actions

  loginRequest,
  loginSuccess,
  loginFail,

  createUserRequest,
  createUserSuccess,
  createUserFail,
  updateUserRequest,
  updateUserSuccess,
  updateUserFail,
  getUserListRequest,
  getUserListSuccess,
  getUserListFail,

  getUserTypeListRequest,
  getUserTypeListSuccess,
  getUserTypeListFail,

  deleteUserRequest,
  deleteUserSuccess,
  deleteUserFail,
  resetUserRequest,
  resetUserSuccess,
  resetUserFail,

  getPageListRequest,
  getPageListSuccess,
  getPageListFail,
  assignPermissionRequest,
  assignPermissionSuccess,
  assignPermissionFail,

  getRoleListRequest,
  getRoleListSuccess,
  getRoleListFail,

  getUserPermissionsRequest,
  getUserPermissionsSuccess,
  getUserPermissionsFail,


} = UserReducer.actions;

export const createUserDispatch = (userData, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(createUserRequest());
    const { data } = await axiosInstance.post('/User/UserRegister', userData, config);

    if (data.status === 1) {
      dispatch(createUserSuccess());
      dispatch(getUserListDispatch(userData, token));
      dispatch(toggleUserModal(false));
    }
    else {
      dispatch(createUserFail(data.message || 'Failed to create user'));
    }
  } catch (error) {
    dispatch(
      createUserFail(
        error.response?.data?.message || error.message
      )
    );
  }
};

export const loginDispatch =
  (bodyData, setLoading, navigate) => async (dispatch) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json'          
        },
      };

      dispatch(loginRequest());
      const { data } = await axiosInstance.post(
        '/user/userlogin',
        bodyData,
        config
      );

      if (data.success && data.statusCode === 200 && data.result?.userToken) {
        const loginInfo = {
          ...data.result,
          token: data.result.userToken,
          result: data.result,
          success: data.success,
          statusCode: data.statusCode,
        };

        dispatch(loginSuccess(loginInfo));
        navigate('/dashboard/default');
        setLoading(false);
      } else {
        setLoading(false);
        const errorMessage =
          data.successMessage ||
          data.errors?.[0]?.message ||
          data.errors?.[0] ||
          'Unable to sign in. Please check your credentials.';
        alert(errorMessage);
        dispatch(loginFail(errorMessage));
      }
    } catch (error) {
      setLoading(false);
      const errorMessage =
        error.response?.data?.successMessage ||
        error.response?.data?.errors?.[0]?.message ||
        error.response?.data?.errors?.[0] ||
        error.response?.data?.message ||
        error.message ||
        'Something went wrong';
      alert(errorMessage);
      dispatch(loginFail(errorMessage));
    }
  };


export const updateUserDispatch = (categoryData, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(updateUserRequest());
    const { data } = await axiosInstance.post(`/User/UpdateUser`, categoryData, config);
    if (data.status === 1) {
      dispatch(updateUserSuccess());
      dispatch(getUserListDispatch(categoryData, token));
      dispatch(toggleUserModal(false));
    }

  } catch (error) {
    dispatch(
      updateUserFail(
        error.response?.data?.message || error.message
      )
    );
  }
};

export const getUserListDispatch = (form, token) => async (dispatch) => {
  try {
    dispatch(getUserListRequest());
    const { data } = await axiosInstance.get(
      '/Employee/GetUsers',
      getAxiosConfig(token)
    );

    dispatch(getUserListSuccess(data));
  } catch (error) {

    dispatch(getUserListFail(getErrorMessage(error)));
  }
};

export const getUserTypeListDispatch = (token) => async (dispatch) => {
  try {
    dispatch(getUserTypeListRequest());
    const { data } = await axiosInstance.get(
      '/UserType/GetUserTypeList',
      getAxiosConfig(token)
    );

    dispatch(getUserTypeListSuccess(data));
  } catch (error) {

    dispatch(getUserTypeListFail(getErrorMessage(error)));
  }
};

export const deleteUserDispatch = (categoryId, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(deleteUserRequest());
    await axiosInstance.delete(`/document-category/${categoryId}`, config);
    dispatch(deleteUserSuccess());
  } catch (error) {
    dispatch(
      deleteUserFail(
        error.response?.data?.message || error.message
      )
    );
  }
};


export const resetUserDispatch = (userData, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(resetUserRequest());
    const { data } = await axiosInstance.post('/User/ResetPassword', userData, config);

    if (data.status === 1) {
      dispatch(resetUserSuccess());
      dispatch(getUserListDispatch(userData, token));
    }
  } catch (error) {
    dispatch(
      createUserFail(
        error.response?.data?.message || error.message
      )
    );
  }
};

export const changeUserPasswordDispatch = (userData, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };

    dispatch(resetUserRequest());

    const { data } = await axiosInstance.post('/User/ChangeInAppPassword', userData, config);

    if (data.status === 1) {
      dispatch(resetUserSuccess());
      dispatch(getUserListDispatch(userData, token));
      dispatch(toggleUserPasswordResetModal(false));
    } else {
      // Backend returned status 0
      dispatch(resetUserFail(data.message || 'Password change failed'));
    }

  } catch (error) {
    dispatch(
      resetUserFail(
        error.response?.data?.message || error.message || 'Something went wrong'
      )
    );
  }
};



export const getPageListDispatch = (token) => async (dispatch) => {
  try {
    dispatch(getPageListRequest());
    const { data } = await axiosInstance.get('/Authorization/PageList', getAxiosConfig(token));

    if (data.status === 1) {
      dispatch(getPageListSuccess(data.data));
    } else {
      dispatch(getPageListFail(data.message || 'Failed to fetch page list'));
    }
  } catch (error) {
    dispatch(getPageListFail(getErrorMessage(error)));
  }
};
export const assignPagePermissionDispatch = (permissionData, token) => async (dispatch) => {
  try {
    dispatch(assignPermissionRequest());
    const { data } = await axiosInstance.post(
      '/Authorization/AssignPagePermission',
      permissionData,
      getAxiosConfig(token)
    );

    if (data.status === 1) {
      dispatch(assignPermissionSuccess());
    } else {
      dispatch(assignPermissionFail(data.message || 'Failed to assign permission'));
    }
  } catch (error) {
    dispatch(assignPermissionFail(getErrorMessage(error)));
  }
};

export const getRoleListDispatch = (token) => async (dispatch) => {
  try {
    dispatch(getRoleListRequest());
    const { data } = await axiosInstance.get(
      '/Role/GetRoleList',
      getAxiosConfig(token)
    );

    if (data.status === 1) {
      dispatch(getRoleListSuccess(data.data));
    } else {
      dispatch(getRoleListFail(data.message || 'Failed to fetch roles'));
    }
  } catch (error) {
    dispatch(getRoleListFail(getErrorMessage(error)));
  }
};

export const getUserPermissionListDispatch = (token) => async (dispatch) => {
  try {
    dispatch(getUserPermissionsRequest());
    const { data } = await axiosInstance.get(
      '/Authorization/GetPagePermissionList',
      getAxiosConfig(token)
    );

    if (data.status === 1) {
      const processed = data.data.map((item) => ({
        pageUrl: item.pageUrl,
        functionalityList: item.functionalityList,
      }));

      dispatch(getUserPermissionsSuccess(processed));
    } else {
      dispatch(getUserPermissionsFail(data.message || 'Failed to fetch user permissions'));
    }
  } catch (error) {
    dispatch(getUserPermissionsFail(getErrorMessage(error)));
  }
};


export default UserReducer;
